import { Link } from "react-router-dom";
import logo from "../../assets/logos/logo.png";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="/">
          <img src={logo} alt="Accium" />
        </a>
      </div>
      <ul className="navbar-links">
        <li><Link to="/catalogo">Catálogo</Link></li>
        <li><a href="/#services">Serviços</a></li>
        <li><a href="/#about">Sobre</a></li>
        <li><Link to="/promo">Ganhe</Link></li>
        <li><Link to="/contato">Contato</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
